module.exports = __webpack_public_path__ + "img/dsci0023.2efd7d4a.jpg";